import { Button } from "@/components/ui/button";

interface OrderFiltersProps {
  selectedOrderType: string;
  onOrderTypeChange: (type: string) => void;
  /** Delivery rows are only in the queue while the Delivery toggle is on. */
  includeDelivery?: boolean;
}

const OrderFilters = ({
  selectedOrderType,
  onOrderTypeChange,
  includeDelivery = false,
}: OrderFiltersProps) => {
  // Delivery narrows to rows that only exist while the toggle includes them, so
  // the chip appears with them rather than sitting there as a dead control.
  const orderTypes = [
    { value: "All", label: "All" },
    { value: "Dine In", label: "Dine In" },
    { value: "Carryout", label: "Carryout" },
    ...(includeDelivery ? [{ value: "Delivery", label: "Delivery" }] : []),
  ];

  const chipClass = (selected: boolean) =>
    `h-11 px-4 text-sm font-medium ${
      selected
        ? "bg-brand-green text-brand-white hover:bg-brand-green/90 border-transparent"
        : "border-border text-muted-foreground hover:bg-muted hover:text-foreground"
    }`;

  return (
    <div className="space-y-2">
      <h3 className="text-xs font-bold uppercase tracking-wide text-muted-foreground">Order type</h3>
      <div className="flex flex-wrap gap-2">
        {orderTypes.map((type) => (
          <Button
            key={type.value}
            variant="outline"
            onClick={() => onOrderTypeChange(type.value)}
            aria-pressed={selectedOrderType === type.value}
            className={chipClass(selectedOrderType === type.value)}
          >
            {type.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default OrderFilters;
